import React from "react";
import "../style/agentsList.css";
import AgentsListFilters from "./agentsListFilters";
import ChangeSolicitorsLawsysAgent from "./changeSolicitorsLawsysAgent";
import "../style/dots.css";
import SolicitorGroupHOC from "../containers/SolicitorGroups/solicitorGroupHOC"
import FormResponseMessage from "./formResponseMessage";
import Button from "./button";
import CenteredDots from "./General/centeredDots";
import {LEGAL_ADVICE_TEXT, TABLE_VIEW_OPTIONS, TOBA_SHORT_TEXT, TOBA_PATH} from "../helpers/variables";
import CustomTable from "./General/customTable/CustomTable";
import {Link} from "react-router-dom";

const columns = [
	{propertyName: "lawsysId", header: "LawsysID", id: "orderByLawsysId", sortable: true},
	{
		propertyName: "lawsysName",
		header: LEGAL_ADVICE_TEXT,
		formatter: (row) => row.lawsysName ? row.lawsysName.replace(/\(ID:\s\d*\)$/g, '') : "",
		id: "orderByLawsysName",
		sortable: true
	},
	{
		propertyName: "name",
		header: "Name",
		formatter: (row) => `${row.forename} ${row.surname}`,
		id: "orderBySolicitorName",
		sortable: true
	},
	{propertyName: "username", header: "User Name", id: "orderByUserName", formatter: (row) => (
			<Link to={'/solicitors/edit-solicitor/' + row.userId}>
				{row.username}
			</Link>
	), sortable: true},
	{propertyName: "status", header: "Status" , formatter: (row) => (
		<div>
			<svg xmlns="http://www.w3.org/2000/svg" style={{fill: row.status ?'#94b494':'#e0666c'}} width={'12px'}
				 height={'12px'} viewBox="0 0 12 12"><title>Asset 4</title>
				<g id="Layer_2" data-name="Layer 2">
					<g id="info">
						<circle className="cls-1" cx="6" cy="6" r="6"/>
					</g>
				</g>
			</svg>
			&nbsp;
			{
				row.status ? 'Active':'Inactive'
			}
		</div>
	)},
];

const AgentsList = (props) => {
	const {onQuickSearch} = props;
	return (
		<div className="agents-list-wrapper-size form-group">
			{
				props.AgentsList.openNewSolicitorGroupModal ?
					<div className="agentsList-new-sol-group-modal">
						<div className="appFormRefSettings-modal-content">
							<div className="appFormRefSettings-close-button" onClick={()=>props.changeAgentsListSettings('openNewSolicitorGroupModal',false)}> </div>
							<SolicitorGroupHOC/>
						</div>
					</div>
					:
					null
			}
			{props.AgentsList.displayModal ?
				<ChangeSolicitorsLawsysAgent
					selectedLawsysId={props.selectedLawsysId}
					selectedSolicitorUsers={props.selectedSolicitorUsers}
					changeAgentsListSettings={props.changeAgentsListSettings}
					calculateLawsysName={props.calculateLawsysName}
					DisplayConfirm={props.DisplayConfirm}
					DisplayModal={props.DisplayModal}
					SelectLawsysId={props.SelectLawsysId}
					AgentsList={props.AgentsList}
					lawsysFirms = {props.lawsysFirms}
					AttachLawsys={props.AttachLawsys}
				/>
				: null
			}
			<div className="row ">
				<div className="col-sm-12 ">
					<h2 className="agents-list-title">
						{LEGAL_ADVICE_TEXT} Users (ATE)
					</h2>
				</div>
			</div>
			<div className="row">
				<div className="col-sm-12">
					<Button clickHandler={()=>props.push('/solicitors/add-solicitor')} wrapper="btn-wrapper"
									btnType="button" btnStyle={'btn btn-primary btn-xs sharp yellow'}
									label={`Create ${LEGAL_ADVICE_TEXT} User`}/>
					<Button clickHandler={()=>props.push('/solicitors/solicitor-groups')} wrapper="btn-wrapper"
									btnType="button" btnStyle={'btn btn-primary btn-xs sharp yellow'}
									label={`View ${LEGAL_ADVICE_TEXT} Groups`}/>
					{
						props.user.loggedInUser.allowedToEditTobas?
							<Button clickHandler={() => props.push(`/solicitors/${TOBA_PATH}s`)} wrapper="btn-wrapper"
									btnType="button" btnStyle={'btn btn-primary btn-xs sharp yellow'}
									label={`View ${TOBA_SHORT_TEXT}s`}/>
									
							:
							null
					}
				</div>
			</div>
			<AgentsListFilters
				onQuickSearch={onQuickSearch}
				lawsysFirms = {props.lawsysFirms}
				User={props.AgentsList}
				UpdateSolicitorsDisplayedUsers={props.UpdateSolicitorsDisplayedUsers}
				ChangeSolicitorsStatus={props.ChangeSolicitorsStatus}
				DisplayModal={props.DisplayModal}
				FilterByLawsysId={props.FilterByLawsysId}
				UpdateSolicitors={props.UpdateSolicitors}
				UpdateCheckedSolicitors={props.UpdateCheckedSolicitors}
				solicitorUsersAgentsFilter={props.solicitorUsersAgentsFilter}
				agents={props.AgentsList.allSolicitorUsers}
				SolicitorDisplaySetting={props.SolicitorDisplaySetting}
				receiveGetSolicitors = {props.receiveGetSolicitors}
				getSolicitors = {props.getSolicitors}
			/>
			{
				((props.AgentsList.fetching === true) && (props.AgentsList.allSolicitorUsers.length === 0)) ?
					<CenteredDots/>
					:
                    props.AgentsList.allSolicitorUsers.length > 0?
                        <div>
							<CustomTable
								onSortedChange={(columnId) => props.sortAgentsList(columnId)}
								orderBy={props.AgentsList.solicitorUsersListSettings.sortBy}
								orderAsc={props.AgentsList.solicitorUsersListSettings.sortOrder === 'asc'}
								onSelectedActionApply={props.handleApplyActions}
								onSelectAction={(evt) => {
									props.UpdateCheckedSolicitors(evt.target.value)
								}}
								selectedAction={props.AgentsList.solicitorUsersListSettings.action}
								selectActions={[
									{key: 'enable', label: 'Enable User(s)'},
									{key: 'disable', label: 'Disable User(s)'},
									{key: 'changeLawsys', label: `Change ${LEGAL_ADVICE_TEXT}`},
								]}
								onSelectAll={props.CheckAll}
								onDatumSelect={(checked, rowIndex, row) => props.CheckSolicitor({checked, rowIndex, row})}
								selected={props.AgentsList.selectedSolicitorUsers}
								selectable
								accordionItemHeaderFormatter={(row) => (
									`LawsysID: ${row.lawsysId} User Name: ${row.username}`
								)}
								onPageSizeChange={evt => props.SolicitorDisplaySetting('displayAmount', parseInt(evt.target.value))}
								goAtPage={props.SolicitorDisplaySetting}
								onPageShift={props.solicitorUsersPagination}
								loading={props.AgentsList.fetching}
								responsive
								striped
								columns={columns}
								data={props.AgentsList.allSolicitorUsers}
								pageSize={parseInt(props.AgentsList.solicitorUsersListSettings.displayAmount)}
								totalRecords={props.AgentsList.solicitorUsersListSettings.totalRecords}
								totalPages={props.AgentsList.solicitorUsersListSettings.totalBoxes}
								page={props.AgentsList.solicitorUsersListSettings.page}
								pageSizeOptions={TABLE_VIEW_OPTIONS}
							/>
                        </div>
						:
                        <div className="text-center">
                            <span>No {LEGAL_ADVICE_TEXT.toLowerCase()} user to show.</span>
                        </div>
			}
            {
                props.AgentsList.badPatchResponse?
                    <div className="row">
                        <FormResponseMessage Message={props.AgentsList.badPatchResponse} CenterWrapper="col-sm-12 mt-15 mb-15" MessageStyle="formResponseMessage-reject" />
                    </div>
                    :
                    null
            }
		</div>
	)
};

export default AgentsList
